// import { Add16 } from '@carbon/icons-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Task } from 'data/tasks';
import { useTasksByIdsFromRQ } from 'data/tasks/hooks';
import {
  // AddItemButton,
  // AddItemWrapper,
  PreTitle,
  SectionName,
  SectionWrapper,
  TitleWrapper,
  CpSubTaskCard,
} from './components';

interface Props {
  task: Task;
}

export const CpTaskDependentTasksSection: React.FC<Props> = ({ task }) => {
  const { data: depTasksFromRQ, refetch } = useTasksByIdsFromRQ(
    ['project_id', (task?.project as any)?.projectId ?? -1],
    task?.dependentTasks?.map((e) => e?.taskId) ?? [],
  );

  return (
    <SectionWrapper>
      <PreTitle>
        {task?.dependentTasks?.length} <FormattedMessage id="dependent_tasks" />
      </PreTitle>
      <TitleWrapper>
        <SectionName>
          <FormattedMessage id="dependent_tasks" />
        </SectionName>
      </TitleWrapper>
      {depTasksFromRQ?.length ? (
        depTasksFromRQ?.map((depTask, index) => (
          <CpSubTaskCard
            subTask={depTask}
            projectId={(task?.project as any)?.projectId}
            refetch={refetch}
            isLastCard={index === depTasksFromRQ.length - 1}
          />
        ))
      ) : (
        <></>
      )}
      {/* <AddItemWrapper withTopMargin>
        <Add16 />
        <AddItemButton>
          <FormattedMessage id="dependent_tasks.add" />
        </AddItemButton>
      </AddItemWrapper> */}
    </SectionWrapper>
  );
};
